export class ChatMessageType {
  static agentMessageType = 'agent';
  static userMessageType = 'user';
  static infoMessageType = 'info';
}
